import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

function getVisitorId() {
  let vid = localStorage.getItem("gc_vid");
  if (!vid) {
    vid = (crypto.randomUUID && crypto.randomUUID()) || `v-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("gc_vid", vid);
  }
  return vid;
}

export default function AnalyticsTracker() {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return; // non tracciare il pannello admin
    const kind = user ? "registered" : localStorage.getItem("gc_newsletter") === "1" ? "newsletter" : "anonymous";
    api.post("/analytics/track", { path: location.pathname, visitor_id: getVisitorId(), kind }).catch(() => {});
  }, [location.pathname, user]);

  return null;
}
